
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy/service",
      function () {
        return require("private-next-pages/policy/service.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy/service"])
      });
    }
  